import React from "react";
import { Checkbox, FormControlLabel, Grid, Paper } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import { validations } from "./validations";
import { makeStyles } from "@mui/styles";
import { getCodigoUsuario } from "../../../../utils/Common";
import Api from "../../../../utils/services/Api";
import EndPoints from "../../../../utils/services/EndPoints";
import { useEdicionSocio } from "../../../../context/socio/use-edicion-socio";
import SelectWithServerData from "../../../../components/Select/SelectWithServerData";
import { LoadingButton } from "@mui/lab";
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    padding: 16
  }
}));

const AgregarActividadSection = ({
  disabled,
  onSubmitted,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const {
    infoSocio: {
      datosBasicosMs: {
        codigoPersona
      }
    },
  } = useEdicionSocio()
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    touched,
    errors,
    isSubmitting,
  } = useFormik({
    initialValues: {
      idActividadEconomica: "",
      esPrincipal: false,
    },
    validationSchema: yup.object().shape(validations),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const usuario = getCodigoUsuario();
        const body = {
          codigo: 0,
          codigoUsuarioActualiza: usuario,
          codigoUsuarioRegistra: usuario,
          esPrincipal: values.esPrincipal ? "S" : "N",
          estado: 'S',
          fechaActualiza: new Date(),
          fechaRegistro: new Date(),
          actividadEconomicaMs: {
            codigo: values.idActividadEconomica
          },
          personaMs: {
            codigo: codigoPersona
          },
        };
        await Api(EndPoints.addActividadEconomica, "POST", body)
        enqueueSnackbar("Agregado correctamente", { variant: "success" })
        resetForm()
        onSubmitted()
      } catch (error) {
        enqueueSnackbar(error.message, { variant: "error" })
      } finally {
        setSubmitting(false)
      }
    },
  });

  return (
    <Paper
      variant="outlined"
      classes={{
        root: classes.paperContainer
      }}
    >
      <Grid container spacing={2} component="form" onSubmit={handleSubmit} alignItems="center">
        <Grid item xs={12} md={8}>
          <SelectWithServerData
            id="idActividadEconomica"
            label="Actividad Económica"
            value={values.idActividadEconomica}
            onChange={handleChange("idActividadEconomica")}
            endpoint={EndPoints.listaActividadesEconomicas}
            onBlur={handleBlur}
            helperText={touched.idActividadEconomica ? errors.idActividadEconomica : ""}
            error={touched.idActividadEconomica && Boolean(errors.idActividadEconomica)}
            disabled={isSubmitting || disabled}
          />
        </Grid>
        <Grid item container xs={12} md={2} justifyContent="center">
          <FormControlLabel
            onChange={handleChange}
            disabled={disabled}
            control={
              <Checkbox
                checked={values.esPrincipal}
                name="esPrincipal"
                color="primary"
              />
            }
            label="Es principal"
          />
        </Grid>
        <Grid item xs={12} md={2} sx={{ textAlign: "center" }}>
          <LoadingButton
            type="submit"
            variant="outlined"
            color="primary"
            loading={isSubmitting}
            startIcon={
              <AddIcon />
            }
            disabled={disabled}
            loadingPosition="start"
          >
            <span>Agregar</span>
          </LoadingButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AgregarActividadSection;
